import React from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"

const SterilizationMethod = ({
	UDI,
	setUDI,
	forceIsEditing = null
}) => {

	const fieldName = "SterilizationMethod";
	const fieldTitle = "Sterilization Method";
	const LOV = [

		{ key: "", value: "" },
		{ key: "Chlorine Dioxide (ClO2) Sterilization", value: "Chlorine Dioxide (ClO2) Sterilization" },
		{ key: "Dry Heat Sterilization", value: "Dry Heat Sterilization" },
		{ key: "Ethylene Oxide Sterilization", value: "Ethylene Oxide Sterilization" },
		{ key: "High Intensity Light or Pulse Light Sterilization", value: "High Intensity Light or Pulse Light Sterilization" },
		{ key: "High-level Disinfectant Sterilization", value: "High-level Disinfectant Sterilization" },
		{ key: "Hydrogen Peroxide (H2O2) Sterilization", value: "Hydrogen Peroxide (H2O2) Sterilization" },
		{ key: "Liquid Chemical Sterilization", value: "Liquid Chemical Sterilization" },
		{ key: "Microwave Radiation Sterilization", value: "Microwave Radiation Sterilization" },
		{ key: "Moist Heat or Steam Sterilization", value: "Moist Heat or Steam Sterilization" },
		{ key: "Nitrogen Dioxide Sterilization", value: "Nitrogen Dioxide Sterilization" },
		{ key: "Ozone (O3) Sterilization", value: "Ozone (O3) Sterilization" },
		{ key: "Peracetic Acid Sterilization", value: "Peracetic Acid Sterilization" },
		{ key: "Radiation Sterilization", value: "Radiation Sterilization" },
		{ key: "Sound Waves Sterilization", value: "Sound Waves Sterilization" },
		{ key: "Sterilization Method", value: "Sterilization Method" },
		{ key: "Supercritical Carbon Dioxide Sterilization", value: "Supercritical Carbon Dioxide Sterilization" },
		{ key: "Ultraviolet Light Sterilization", value: "Ultraviolet Light Sterilization" }
	];

	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} forceIsEditing={forceIsEditing} />
	</>											  
}


export default SterilizationMethod;


